<template>
  <ejs-dialog v-if="hackReset" :ref='refName'
              :target='target'
              :isModal='isModal'
              :width='width'
              :height='height'
              :header='header'
              :buttons='buttonGroup'
              v-bind:visible='visible'
              :showCloseIcon='closeIcon'>
      <div style="width:100%;height:90%;">{{tipData.tipInfo}}</div>
  </ejs-dialog>
</template>
<script>
const defaultWidth = '20%';
const defaultHeight = '23%';
const defaultHeader = 'Info';
const dafaultVisible = false;
const deaultModel = true;
const defaultClose = true;

export default {
  name: 'LayerDialog',
  props: [
    'element',
    'styles',
    'tipInfos'
  ],
  data() {
    return {
      tipData: {
        tipInfo: this.tipInfos
      },
      hackReset: true,
      target: this.element.target,
      width: typeof (this.styles) === 'undefined' || !this.styles.width ? defaultWidth : this.styles.width,
      height: typeof (this.styles) === 'undefined' || !this.styles.height ? defaultHeight : this.styles.height,
      header: !this.element.title ? defaultHeader : this.element.title,
      visible: typeof (this.styles) === 'undefined' || !this.styles.visible ? dafaultVisible : this.styles.visible,
      isModal: typeof (this.styles) === 'undefined' || !this.styles.model ? deaultModel : this.styles.model,
      closeIcon: !this.element && !this.element.isClose ? defaultClose : this.element.isClose,
      buttonGroup: this.element.buttonGroup,
      refName: this.element.refName,
    };
  },
  mounted() {
    this.$refs[`${this.refName}`];
  },
  methods: {
    show(name) {
      this.tipData.tipInfo = name;
      this.$refs[`${this.refName}`].show();
    },
    close() {
      this.clear();
      this.$refs[`${this.refName}`].hide();
    },
    clear() {
      this.hackReset = false;
      this.$nextTick(() => {
        this.hackReset = true;
      });
    }
  },
  watch: {
    'element.title': function (val) {
      this.header = val;
    },
    'element.buttonGroup': function (val) {
      this.buttonGroup = val;
    }
  }
};
</script>
<style>
</style>
